import { render } from "./lowRatingModal.vue?vue&type=template&id=01eab69b&scoped=true"
import script from "./lowRatingModal.vue?vue&type=script&lang=js"
export * from "./lowRatingModal.vue?vue&type=script&lang=js"

import "./lowRatingModal.vue?vue&type=style&index=0&id=01eab69b&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01eab69b"]])

export default __exports__